import { baseUrl } from '../http'
import axios from 'axios'
import { TokenStorage } from "../token";

export const auth = {
  login(username, password) {
    return axios.put(`${baseUrl}/user/login`, {
      username: username,
      password: password,
      rememberMe: true
    }).then(res => {
      if (!res.data.success) {
        throw Error()
      }

      TokenStorage.storeToken(res.data.token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${res.data.token}`;
      axios.defaults.headers.common['Content-Type'] = 'application/json';
      axios.defaults.baseURL = baseUrl;

      return res.data.user;
    })
  },

  signup(signUpData){
    return axios.post(`${baseUrl}/user/signup`, signUpData)
    .then(res=>{
      return !!res.data.success;
    }).catch(er=>{
      console.log(er);
      })
  }
}
